import React from "react";

const Checkbox = ({ label, checked, onChange, errorMessage }) => {
  return (
    <label className="flex cursor-pointer items-start gap-2 rounded-md">
      <div className="relative">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="h-6 w-6 cursor-pointer appearance-none rounded-[4px] border-2 border-white focus:outline-none bg-white"
        />
        {checked && (
          <span className="absolute left-1 top-1 h-4 w-4 rounded-[2px] bg-red"></span>
        )}
      </div>
      <div>
        <p
          dangerouslySetInnerHTML={{ __html: label }}
          className={` ${errorMessage ? "text-accentRed" : "text-red"}`}
        ></p>
      </div>
    </label>
  );
};

export default Checkbox;
